const CertificationsTemplate = () => {
    return ( 
        <></>
     );
}
 
export default CertificationsTemplate;